import React from 'react'

import {noop} from 'es-toolkit'

import './text-field.scss'

import useUniqueId from '../../hooks/use-unique-id'
import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    value: string
    id?: string
    name?: string
    size?: '90' | '100' | '200'
    appearance?: 'base' | 'error'
    placeholder?: string
    rows?: number
    maxLength?: number
    disabled?: boolean
    autoFocus?: boolean
    onChange?: (
      value: string,
      name: string | undefined,
      event: React.ChangeEvent<HTMLTextAreaElement>
    ) => void
    onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void
    onFocus?: (event: React.FocusEvent<HTMLTextAreaElement>) => void
    textareaRef?: React.RefObject<HTMLTextAreaElement | null>
  }
>

const TextField = ({
  className,
  value,
  id,
  name,
  appearance = 'base',
  size = '100',
  placeholder,
  rows,
  maxLength,
  disabled = false,
  autoFocus = false,
  onBlur = noop,
  onFocus = noop,
  onChange = noop,
  textareaRef,
  ...props
}: Props) => {
  const actualId = useUniqueId(id)

  return (
    <div
      {...props}
      className={cn(
        'TextField',
        {
          [`size-${size}`]: !!size,
          [`appearance-${appearance}`]: !!appearance,
          disabled,
        },
        className
      )}
    >
      <div className="TextField__main">
        <textarea
          ref={textareaRef}
          className="TextField__input"
          name={name}
          id={actualId}
          placeholder={placeholder}
          value={value}
          rows={rows}
          disabled={disabled}
          autoFocus={autoFocus}
          onChange={e => onChange(e.target.value, name, e)}
          onBlur={onBlur}
          onFocus={onFocus}
          maxLength={maxLength}
        />
      </div>
      {maxLength && (
        <span className="TextField__maxLength-indicator">
          {value.length}/{maxLength}
        </span>
      )}
    </div>
  )
}

export default TextField
